<div
  class="grid cursor-pointer grid-cols-[2fr_1fr_1fr_1fr_1fr_auto] items-center gap-2 px-5 py-3 transition-colors hover:bg-slate-50"
  [class.opacity-40]="document().deletedAt"
  [attr.data-testid]="'document-row-' + document().id"
  (click)="onRowClick()"
>
  <!-- Document: icon + filename + reference -->
  <div class="flex min-w-0 items-center gap-3">
    <i class="pi shrink-0 text-xl text-rose-400" [class]="mimeIcon()"></i>
    <div class="min-w-0">
      <p class="m-0 truncate text-sm font-semibold text-slate-800">
        {{ document().storageFile.originalName }}
      </p>
      @if (document().reference) {
        <p class="m-0 truncate text-xs text-slate-400">{{ document().reference }}</p>
      }
    </div>
  </div>

  <!-- Type -->
  <span class="truncate text-sm text-slate-600">{{ typeLabelKey() | translate }}</span>

  <!-- Supplier -->
  <span class="truncate text-sm text-slate-600">{{ document().supplierName ?? '—' }}</span>

  <!-- Amount + Date -->
  <div class="text-right">
    @if (document().value !== undefined && document().value !== null) {
      <p class="m-0 font-mono text-sm font-semibold text-slate-800">
        {{ document().value | number: '1.2-2' }} {{ document().currency ?? 'RON' }}
      </p>
    } @else {
      <p class="m-0 text-sm text-slate-300">—</p>
    }
    @if (document().documentDate) {
      <p class="m-0 text-xs text-slate-400">{{ document().documentDate | date: 'dd.MM.yyyy' }}</p>
    }
  </div>

  <!-- Status -->
  <div>
    <p-tag
      [value]="statusLabelKey() | translate"
      [severity]="statusSeverity()"
      [rounded]="true"
      styleClass="text-xs"
    />
  </div>

  <!-- Actions -->
  <div class="flex w-8 justify-end">
    <p-button
      icon="pi pi-download"
      severity="secondary"
      size="small"
      [text]="true"
      data-testid="document-row-download-button"
      (onClick)="onDownload($event)"
    />
  </div>
</div>
